module.exports = __webpack_public_path__ + "static/img/day-9.5d4cf66.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-9.png
// module id = YsOu
// module chunks = 1